import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { hosts } from '../environments/environment';
import { AuthInterceptor } from './interceptors/httpconfig.interceptor';
import { NotFoundComponent } from './notFound/notFound.component';
//import { CalendarModule, DateAdapter } from 'angular-calendar';
//import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
//import '@progress/kendo-angular-intl/locales/es/all';
//import { GridModule } from '@progress/kendo-angular-grid';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    /*CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),*/
    //GridModule,
  ],
  providers: [
      { provide: 'API_BASE_URL', useFactory: getBaseUrl },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },{ provide: LOCALE_ID, useValue: 'es-ES' },
      HttpClient
  ],
  exports: [
    TranslateModule,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getBaseUrl(): string {
  return hosts.API_BASE;
}
